import { TextBIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Bold = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <TextBIcon {...rest} size={Sizes[size]} color={fill} />;
};

Bold.displayName = 'Bold';
